export const status = {
    0: {
        id: 1,
        text: 'Inactivo', // translate
        type: 'danger'
    },
    1: {
        id: 2,
        text: 'Activo', // Translate
        type: 'success'
    },
};

export const levels = {
    1: 'fraudPrevention.levels.1',
    2: 'fraudPrevention.levels.2',
    3: 'fraudPrevention.levels.3',
    4: 'fraudPrevention.levels.4',
    5: 'fraudPrevention.levels.5'
};

export const period = {
    day: 'fraudPrevention.period.day',
    month: 'fraudPrevention.period.month',
};
